import { usePage } from "@inertiajs/react";
import type { PropsWithChildren } from "react";
import AppLogoIcon from "@/components/app-logo-icon";
import { AppVersion } from "@/components/app-version";
import { CertificationBanner } from "@/components/certification-banner";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import type { SharedData } from "@/types";

type AuthSplitLayoutFormSideProps = {
  description?: string | null;
  title?: string | null;
};

export default function AuthSplitLayoutFormSide({
  children,
  description,
  title,
}: PropsWithChildren<AuthSplitLayoutFormSideProps>) {
  const { name, config } = usePage<SharedData>().props;

  return (
    <div className="mt-4 w-full lg:mt-0 lg:p-8">
      <Card className="mx-auto flex w-full flex-col justify-center gap-0 space-y-6 rounded-3xl shadow-md sm:w-[350px] md:w-[400px]">
        <CardHeader>
          <a
            className="relative z-20 flex items-center justify-center lg:hidden"
            href={config.marketingSiteUrl}
          >
            <AppLogoIcon
              className="h-10 fill-current text-black sm:h-12 dark:text-white"
              name={name}
            />
          </a>
          <div className="flex flex-col items-center text-center">
            <h1 className="font-semibold text-2xl">{title}</h1>
            {description && (
              <p className="text-balance text-muted-foreground text-sm">
                {description}
              </p>
            )}
          </div>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>

      <CertificationBanner />
      <AppVersion />
    </div>
  );
}
